import { QuizQuestion } from '~teacher/models/quizzes';

export const copyQuizQuestions = (quizQuestion: Record<string, QuizQuestion>) =>
  ({ ...quizQuestion } as Record<string, QuizQuestion>);

export const indexQuestionByOrder = (
  quizQuestion: Record<string, QuizQuestion>
) =>
  Object.values<QuizQuestion>(quizQuestion)
    .sort((a, b) => a.order - b.order)
    .map((qq) => qq.questionId as number);

export const normalizeQuestions = (
  quizQuestion: Record<string, QuizQuestion>
) => ({
  byOrder: indexQuestionByOrder(quizQuestion),
  entities: copyQuizQuestions(quizQuestion),
});

export type NormalizedQuestion = ReturnType<typeof normalizeQuestions>;
